import React, { Component } from "react";
import LazyLoad from "react-lazyload";
import Ink from "react-ink";
import Swing from "react-reveal/Swing";
import ContentLoader from "react-content-loader";
import { NavLink } from "react-router-dom";

class PromoSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSlideIndex: 0,
    };
  }

  componentDidMount() {
    this.startSlider();
  }

  componentWillUnmount() {
    this.stopSlider();
  }

  startSlider = () => {
    this.sliderInterval = setInterval(this.changeSlide, 15000);
  };

  stopSlider = () => {
    clearInterval(this.sliderInterval);
  };

  changeSlide = () => {
	const { slides } = this.props;
	const { currentSlideIndex } = this.state;
  
	console.log("Índice actual:", currentSlideIndex);
	console.log("ID del slide actual:", slides[currentSlideIndex].data.id);
	console.log("Imagen del slide actual:", slides[currentSlideIndex].data.image);
  
	this.setState((prevState) => ({
	  currentSlideIndex: (prevState.currentSlideIndex + 1) % slides.length,
	}));
  };
  

  render() {
    const { slides, size, secondarySlider } = this.props;
    const { currentSlideIndex } = this.state;

    console.log("Número total de slides:", slides.length);
    console.log("Índice actual:", currentSlideIndex);

    return (
      <div
        className={
          secondarySlider
            ? "slider-wrapper secondary-slider-wrapper my-20"
            : "slider-wrapper bg-light py-20 my-0"
        }
      >
        {slides.length === 0 ? (
           <ContentLoader
		   height={170}
		   width={400}
		   speed={1.2}
		   primaryColor="#f3f3f3"
		   secondaryColor="#ecebeb"
		 >
		   <rect x="20" y="0" rx="4" ry="4" width="168" height="168" />
		   <rect x="228" y="0" rx="4" ry="4" width="168" height="168" />
		 </ContentLoader>
        ) : (
          slides.map((slide, index) => (
			<a
			href={slide.url}
			className="slider-wrapper__img-wrapper"
			key={slide.data.id}
			style={{ position: "relative",textAlign: "center"  }}
		>
			<NavLink
                  to={"../" + slide.url}
                  className="slider-wrapper__img-wrapper"
                  key={slide.data.id}
                  style={{ position: "relative", display: index === currentSlideIndex ? "block" : "none" ,textAlign: "center" }}
                >
			<Swing>


                
              
		 <div
    key={slide.data.id}
 
  >
    <a href={slide.url} className="slider-wrapper__img-wrapper">
		
      <img
        src={slide.data.image}
        alt={slide.data.name}
        className={`slider-wrapper__img slider-cust-img ${!secondarySlider &&
          "slider-wrapper__img-shadow"} custom-promo-img`}
        style={{
			height: `12rem`,
			width: `12rem`,
        }}
        loading="lazy"
      />
   
    </a>
  </div>

		  </Swing>
		  </NavLink>
		  <Ink hasTouch={true} />
		  </a>
          ))
        )}
      </div>
    );
  }
}

export default PromoSlider;
